var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "product-card-cart-like",
      attrs: {
        "aria-label": "Add to your favourites",
        disabled: _vm.wishlistProcessing,
      },
      on: { click: _vm.addToWishlist },
    },
    [_c("i", { class: _vm.favouriteState })]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }